import React, { Component } from 'react'
import { Modal, ModalFooter } from 'reactstrap'
import styled from 'styled-components'
import { withNamespaces } from 'react-i18next'
import moment from 'moment'

import Preloader from '../UI/Preloader'

import StyledButton from '../Forms/Button'

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 30px 25px 30px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
`

const StyledTitle = styled.div`
  margin-bottom: 15px;
  font-size: 13px;
  text-align: center;
  color: #19233c;
  text-transform: uppercase;
`

const StyledImage = styled.img`
  width: 100%;
  max-height: 300px;
  object-fit: contain;
`

const StyledInfoBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 13px;
`

const StyledAuthor = styled.div`
  color: #b0bac9;
  font-size: 13px;
  font-weight: 500;
`

const StyledDate = styled.div`
  color: #b0bac9;
  font-size: 11px;
  font-weight: 500;
`

const StyledNewsText = styled.div`
  color: #2e384d;
  font-size: 13px;
  font-weight: 500;
`

const ModalFooterWrapper = styled(ModalFooter)`
  padding-bottom: 0 !important;
  border: none !important;
`

const StyledRatingContainer = styled.div`
  font-family: 'Open Sans', sans-serif;
`

const StyledShowMoreLink = styled.a`
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  text-decoration: none;
  color: rgba(0, 127, 255, 0.8);

  margin-top: 10px;
`

class NewsModal extends Component {
  state = {
    modal: false
  }

  closeModal = () => {
    this.props.toggle()
  }

  render() {
    const { isOpen, t, loading, news } = this.props

    if (!news) return null

    const { authorName, time, title, imageUrl, text, url } = news

    return (
      <React.Fragment>
        <Modal
          isOpen={isOpen}
          toggle={this.closeModal}
          contentClassName="styled_modal_content"
        >
          {loading && <Preloader />}
          <StyledModalContent>
            <StyledTitle>{title}</StyledTitle>
            <StyledRatingContainer>
              {!!imageUrl &&
                (!!url ? (
                  <a href={url} target="_blank">
                    <StyledImage src={imageUrl} />
                  </a>
                ) : (
                  <StyledImage src={imageUrl} />
                ))}
              <StyledInfoBlock>
                <StyledAuthor>{authorName}</StyledAuthor>
                <StyledDate>
                  {moment(time).format('DD/MM/YY - HH:mm')}
                </StyledDate>
              </StyledInfoBlock>
              <StyledNewsText dangerouslySetInnerHTML={{ __html: text }} />
              {!!url && (
                <StyledShowMoreLink href={url} target="_blank">
                  {t('common:moreInfo')}
                </StyledShowMoreLink>
              )}
            </StyledRatingContainer>
            <ModalFooterWrapper>
              <StyledButton onClick={this.closeModal} outline bgColor="#fff">
                {t('common:close')}
              </StyledButton>
            </ModalFooterWrapper>
          </StyledModalContent>
        </Modal>
      </React.Fragment>
    )
  }
}

export default withNamespaces()(NewsModal)
